export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11451.94f664e0.jpg";